// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3PT3I","title":"AfterBackImages_title__3LCsY","images":"AfterBackImages_images__3D02s"};